import React from 'react';
import {useTranslation} from 'react-i18next';
import warning from '../../assets/icons/warning.svg?no-inline';
import {Button} from '@chekin/guestapp-ui-kit';
import {ModalTwoButtons, StyledModal} from './styled';

type IVRetryModalProps = {
  open: boolean;
  onClickTryAgain?: () => void;
  onCancel?: () => void;
};
function IVRetryModal({open, onClickTryAgain, onCancel}: IVRetryModalProps) {
  const {t} = useTranslation();

  return (
    <StyledModal
      open={open}
      title={t('request_timed_out')}
      text={t('try_again_or_contact')}
      iconAlt={t('warning')}
      iconSrc={warning}
      iconProps={{width: 50, height: 50}}
    >
      <ModalTwoButtons>
        <Button onClick={onClickTryAgain}>{t('try_again')}</Button>
        <Button onClick={onCancel} variant="link">
          {t('upload_another_picture')}
        </Button>
      </ModalTwoButtons>
    </StyledModal>
  );
}

export {IVRetryModal};
